const sequence = [2,3,4,5,6,7]

const isValidRut = (rut) => {
    const rutParts = rut.split('-');
    const realRut = rutParts[0].replace(/\./g, '');
    const dv = rutParts[1];
    /* Validar rut */
    let sum = 0;
    const realRutLen = realRut.length;
    let j = 0;
    for(let i = realRutLen - 1; i >= 0; i--) {
        const rutDigit = parseInt(realRut.charAt(i));
        sum += rutDigit * sequence[j];
        j = j === (sequence.length - 1) ? 0 : j + 1;
    }
    const rest = 11 - (sum % 11);
    const isLetter = r => r === 10 ? 'K' : r;
    const computedDv = rest === 11 ? 0 : isLetter(rest);
    //TODO: Change the way of compare
    //eslint-disable-next-line
    return dv == computedDv;
}

const rutValidator = {
    isValidRut,
}

export default rutValidator